import React, { useState, useEffect } from "react";
import RootAdmin from "../../../../../components/layouts/RootAdmin";
import {   Button,
  Card,
  CardBody,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow, } from "@nextui-org/react";
import HeaderPage from "../../../../../components/elements/HeaderPage";
import { ArrowDownOnSquareIcon, ArrowPathIcon, CheckIcon, ClockIcon, DocumentArrowUpIcon, DocumentDuplicateIcon, DocumentPlusIcon, FunnelIcon, ListBulletIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { BarChart } from "@mui/x-charts/BarChart";
import { SparkLineChart } from "@mui/x-charts";
import CountWidget from "../../../../../components/elements/CountWidget";
import CustomDataGrid from "../../../../../components/elements/CustomDataGrid";
import useSWR from "swr";
import { isiSel, kelasKolom, kelasKolomDariData } from "../../../../../services/angkaTabel";
import { getFetcher, HIGHCHART_URL } from "../../../../../services/api";
import ControlledInput from "../../../../../components/elements/ControlledInput";
import { useForm } from "react-hook-form";
import { translateMonth } from "../../../../../services/helpers";
import FilterInTab from "../../../../../components/elements/FilterInTab";
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import highchartsExporting from 'highcharts/modules/exporting';

// Initialize Highcharts exporting modules
highchartsExporting(Highcharts);

export default function IndexPage() {
  const currentDate = new Date();
  const defaultMonth = currentDate.getMonth() + 1;
  const defaultYear = currentDate.getFullYear();

  const [filters, setFilters] = useState({
    b3BulanTahun: { month: defaultMonth, year: defaultYear },
    b3Tahun: { year: defaultYear },
    perusahaan: { year: defaultYear },
    provinsi: { year: defaultYear },
    perbandingan: { year: defaultYear },
  });

  const updateFilter = (key, newFilter) => {
    setFilters((prev) => ({
      ...prev,
      [key]: { ...prev[key], ...newFilter },
    }));
  };

  const { data: b3TerbanyakBulanTahun, mutate: mutateB3TerbanyakBulanTahun } = useSWR(
    `/api/dashboard/penggunaan/bahan-b3-terbanyak-bulan-tahun?startMonth=${filters.b3BulanTahun.month}&startYear=${filters.b3BulanTahun.year}&endMonth=${filters.b3BulanTahun.month}&endYear=${filters.b3BulanTahun.year}`,
    getFetcher
  );

  const { data: b3TerbanyakTahun, mutate: mutateB3TerbanyakTahun } = useSWR(
    `/api/dashboard/penggunaan/bahan-b3-terbanyak-tahun?year=${filters.b3Tahun.year}`,
    getFetcher
  );

  const { data: perusahaanTerbanyak, mutate: mutatePerusahaanTerbanyak } = useSWR(
    `/api/dashboard/penggunaan/company-using-b3-year?year=${filters.perusahaan.year}`,
    getFetcher
  );

  const { data: provinsiTerbanyak, mutate: mutateprovinsiTerbanyak } = useSWR(
    `/api/dashboard/penggunaan/province-using-b3-year?year=${filters.provinsi.year}`,
    getFetcher
  );

  const { data: perbandingan, mutate: mutateperbandingan } = useSWR(
    `/api/dashboard/penggunaan/comparison-usage-purchase-per-year?year=${filters.perbandingan.year}`,
    getFetcher
  );

  const handleFilterApply = (key, filter) => {
    updateFilter(key, filter);

    switch (key) {
      case "b3BulanTahun":
        mutateB3TerbanyakBulanTahun();
        break;
      case "b3Tahun":
        mutateB3TerbanyakTahun();
        break;
      case "perusahaan":
        mutatePerusahaanTerbanyak();
        break;
      case "provinsi":
        mutateprovinsiTerbanyak();
        break;
      case "perbandingan":
        mutateperbandingan();
        break;
      default:
        break;
    }
  };

  return (
    <RootAdmin>
      <HeaderPage title="Grafik Penggunaan Bahan B3" subtitle="Gambaran Umum" />
      <div className="grid grid-rows-1 md:grid-rows-4 gap-3 pt-5">
        <Card>
          <Tabs aria-label="Penggunaan Grafik B3" defaultValue="PenggunaanGrafik">
            {/* <Tab title="Grafik Besaran B3 Terbanyak Bulan Tahun" value="B3Terbanyak">
            <FilterInTab
                filters={filters.b3BulanTahun}
                onApply={(newFilters) => handleFilterApply("b3BulanTahun", newFilters)}
              />
            {renderChartAndTableForRealisasi(
                                    b3TerbanyakBulanTahun?.responseData?.bahanb3,
                                    "Grafik Penyimpanan B3 Per Bulan dan Tahun",
                                    ["Bulan", "Tahun", "Nomor CAS", "Nama Bahan Kimia", "Jumlah Digunakan (Kg)"],
                                  ["periode_bulan","periode_tahun","cas_number","nama_bahan_kimia", "jumlah_digunakan"],
                                  "nama_bahan_kimia",
                                  "jumlah_digunakan"
                                )}
            </Tab> */}
            <Tab title="Grafik Besaran B3 Terbanyak Tahun" value="B3TerbanyakTahun">
            <FilterInTab
                filters={filters.b3Tahun}
                onApply={(newFilters) => handleFilterApply("b3Tahun", newFilters)}
                disableMonth
              />
            {renderChartAndTableForRealisasi(
                                  b3TerbanyakTahun?.responseData?.bahanb3,
                                  "Grafik Penggunaan Bahan B3 Per Tahun",
                                  ["Tahun", "Nomor CAS", "Nama Bahan Kimia", "Jumlah Digunakan (Kg)"],
                                  ["periode_tahun","cas_number","nama_bahan_kimia", "jumlah_digunakan"],
                                  "nama_bahan_kimia",
                                  "jumlah_digunakan"
                              )}
            </Tab>
            <Tab title="Grafik Perusahaan Terbanyak" value="PerusahaanTerbanyak">
            <FilterInTab
                filters={filters.perusahaan}
                onApply={(newFilters) => handleFilterApply("perusahaan", newFilters)}
                disableMonth
              />
              {renderChartAndTableForRealisasi(
                              perusahaanTerbanyak?.responseData?.companies,
                              "Grafik Penggunaan Bahan B3 Per Perusahaan",
                              ["Tahun", "Nama Perusahaan", "Jumlah Digunakan (Kg)"],
                              ["periode_tahun","company_name", "total_b3_used"],
                              "company_name",
                              "total_b3_used"
                            )}
            </Tab>
            <Tab title="Grafik Provinsi Terbanyak" value="ProvinsiTerbanyak">
            <FilterInTab
                filters={filters.provinsi}
                onApply={(newFilters) => handleFilterApply("provinsi", newFilters)}
                disableMonth
              />
              {renderChartAndTableForRealisasi(
                      provinsiTerbanyak?.responseData?.provinces,
                      "Grafik Penggunaan Bahan B3 Per Provinsi",
                      ["Tahun", "Provinsi", "Jumlah Digunakan (Kg)"],
                      ["periode_tahun","province_name", "total_b3_used"],
                      "province_name",
                      "total_b3_used"
                    )}
            </Tab>
            <Tab title="Grafik Perbandingan" value="Perbandingan">
            <FilterInTab
                filters={filters.perbandingan}
                onApply={(newFilters) => handleFilterApply("perbandingan", newFilters)}
                disableMonth
              />
              {renderChartAndTableForComparison(
                              perbandingan?.responseData?.companies,
                              "Perbandingan Penggunaan dan Pembelian Bahan B3",
                              ["Nama Perusahaan", "Penggunaan", "Pembelian Lokal", "Pembelian Impor"],
                              ["company_name", "total_usage", "total_local_purchase", "total_import_purchase"],
                              {
                                xAxisKey: "company_name",
                                xAxisLabel: "Perusahaan",
                                seriesKeys: [
                                  { key: "total_usage", label: "Penggunaan" },
                                  { key: "total_local_purchase", label: "Pembelian Lokal" },
                                  { key: "total_import_purchase", label: "Pembelian Impor" },
                                ],
                              }
                            )}
            </Tab>             
          </Tabs>
        </Card>
      </div>
    </RootAdmin>
  );
}

function renderChartAndTableForRealisasi(data, title, columns, dataKeys, dataGraphSeries, dataGraphxAxis) {
  const safeData = Array.isArray(data) ? [...data] : []; // Pastikan data adalah array dan buat salinan untuk sorting

  // Urutkan data dari nilai terbesar ke terkecil berdasarkan "jumlah_digunakan"
  safeData?.sort((a, b) => (Number(b[dataGraphxAxis]) || 0) - (Number(a[dataGraphxAxis]) || 0));
  const chartOptions = {
    chart: {
      type: "column",
      scrollablePlotArea: {
        minWidth: 400, // Pastikan cukup ruang horizontal
        scrollPositionX: 0,
      },
    },
    title: {
      text: title,
    },
    xAxis: {
      categories: safeData.map((item) => item[dataGraphSeries] || "N/A"),
      title: {
        text: columns[0],
      },
      labels: {
        rotation: -45, // Rotasi label agar tidak tumpang tindih
        style: {
            fontSize: "10px",
          },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Jumlah",
      },
      labels: {
        overflow: "justify",
      },
      labels: {
        formatter: function () {
            return this.value >= 1000000
                ? (this.value / 1000000).toFixed(1) + "M" // Format angka besar ke dalam juta
                : this.value;
        },
    },
    },
    series: [
      {
        name: "Jumlah",
        data: safeData.map((item) => Number(item[dataGraphxAxis]) || 0),
      },
    ],
    tooltip: {
      pointFormatter: function () {
          return `<b>${this.category}</b>: ${this.y.toLocaleString()} Kg`;
        },
    },
    plotOptions: {
        column: {
            dataLabels: {
                enabled: true,
                format: "{point.y:.0f}", // Hanya angka bulat
                style: {
                    fontSize: "10px",
                },
            },
        },
    },
    exporting: {
        url: HIGHCHART_URL,
        enabled: true,
        showTable: true,
    },
  };
  return (
      <>
          <Card radius="sm" className="col-span-4">
              <CardHeader>
                  <span className="text-primary text-xl font-bold">{title}</span>
              </CardHeader>
              <CardBody className="w-full flex flex-col">
              <HighchartsReact highcharts={Highcharts} options={chartOptions} />
              </CardBody>
          </Card>

          <div className="col-span-4 mt-5">
              <Table aria-label="Data Table">
                  <TableHeader>
                      {columns?.map((col, idx) => (
                          <TableColumn key={idx} className={kelasKolomDariData(dataKeys[idx], safeData)}>
                              {col}
                          </TableColumn>
                      ))}
                  </TableHeader>
                  <TableBody>
                      {safeData?.map((item, index) => (
                          <TableRow key={index}>
                              {dataKeys.map((key, idx) => (
                                  <TableCell key={idx} className={kelasKolom(key, item[key])}>
                                      {key === "periode_bulan"
                                          ? translateMonth(item[key]) || "N/A"
                                          : isiSel(key, item[key])}
                                  </TableCell>
                              ))}
                          </TableRow>
                      ))}
                  </TableBody>
              </Table>
          </div>
      </>
  );
}

function renderChartAndTableForComparison(data, title, columns, dataKeys, graphConfig) {
  const safeData = Array.isArray(data) ? [...data] : []; // Pastikan data adalah array dan buat salinan untuk sorting

  // Urutkan data dari nilai terbesar ke terkecil berdasarkan "jumlah_digunakan"
  safeData?.sort((a, b) => (Number(b[graphConfig.xAxisKey]) || 0) - (Number(a[graphConfig.xAxisKey]) || 0));
  return (
      <>
          {/* Card for Chart */}
          <Card radius="sm" className="col-span-4">
              <CardHeader>
                  <span className="text-primary text-xl font-bold">{title}</span>
              </CardHeader>
              <CardBody className="w-full flex flex-col items-center py-5 text-center">
                  <BarChart
                      xAxis={[
                          {
                              scaleType: "band",
                              data: safeData?.map((item) => item[graphConfig.xAxisKey] || "N/A"),
                              label: graphConfig.xAxisLabel || "Category",
                              barGapRatio: 0.1,
                              categoryGapRatio: 0.3,
                          },
                      ]}
                      series={graphConfig.seriesKeys.map((key) => ({
                          name: key.label,
                          data: safeData?.map((item) => item[key.key] || 0),
                      }))}
                      height={300}
                      legend={{
                          show: true,
                          position: "top", // Place legend at the top
                      }}
                  />
              </CardBody>
          </Card>

          {/* Table for Data */}
          <div className="col-span-4 mt-5">
              <Table aria-label="Comparison Data Table">
                  <TableHeader>
                      {columns?.map((col, idx) => (
                          <TableColumn key={idx} className={kelasKolomDariData(dataKeys[idx], safeData)}>
                              {col}
                          </TableColumn>
                      ))}
                  </TableHeader>
                  <TableBody>
                      {safeData?.map((item, index) => (
                          <TableRow key={index}>
                              {dataKeys.map((key, idx) => (
                                  <TableCell key={idx} className={kelasKolom(key, item[key])}>
                                      {key === "periode_bulan"
                                          ? translateMonth(item[key]) || "N/A"
                                          : isiSel(key, item[key] ?? 0)}
                                  </TableCell>
                              ))}
                          </TableRow>
                      ))}
                  </TableBody>
              </Table>
          </div>
      </>
  );
}
